import type { LocalizedDict } from '../index'

// Drive Maintenance — reconciliation ops surface
// (features/admin/DriveMaintenancePage.tsx).

export type DriveMaintenanceStrings = {
  failed: string
  title: string
  description: string
  forcePurge: string
  forcePurgeWarning: string
  run: string
  stats: {
    orphansPurged: string
    sessionsReconciled: string
    sessionsScanned: string
    bytesPurged: string
    rowsChecked: string
    rowsMissingBytes: string
    foldersUnreadable: string
  }
  gated: {
    before: string
    strong: string
    middle: string
    after: string
  }
  integrity: string
  skipped: (reason: string) => string
}

export const driveMaintenanceI18n: LocalizedDict<DriveMaintenanceStrings> = {
  en: {
    failed: 'Failed',
    title: 'Drive Maintenance',
    description:
      'Reconciliation: close orphan upload sessions, purge bytes of files soft-deleted past retention, and check DB↔storage integrity. The daily job runs this automatically at 04:00; trigger it here on demand.',
    forcePurge: 'Force the destructive byte-purge (overrides the D2 durability gate)',
    forcePurgeWarning:
      'This permanently deletes provider bytes of long-soft-deleted files. Only do this once offsite backup + a restore drill exist.',
    run: 'Run reconciliation',
    stats: {
      orphansPurged: 'Orphans purged',
      sessionsReconciled: 'Sessions reconciled',
      sessionsScanned: 'Sessions scanned',
      bytesPurged: 'Bytes purged',
      rowsChecked: 'Rows checked',
      rowsMissingBytes: 'Rows missing bytes',
      foldersUnreadable: 'Folders unreadable',
    },
    gated: {
      before: 'Retention byte-purge is',
      strong: 'gated (D2 durability)',
      middle: '— no bytes were purged. Enable',
      after: 'once offsite backup + a restore drill exist.',
    },
    integrity: 'Integrity',
    skipped: (reason) => `Skipped — ${reason}.`,
  },
  tr: {
    failed: 'Başarısız',
    title: 'Drive Bakımı',
    description:
      'Mutabakat: yarım kalmış yükleme oturumlarını kapatır, saklama süresi dolmuş silinmiş dosyaların verisini temizler ve veritabanı↔depolama tutarlılığını kontrol eder. Günlük iş bunu her gün 04:00’te otomatik çalıştırır; gerekirse buradan elle başlat.',
    forcePurge: 'Kalıcı veri silmeyi zorla (D2 dayanıklılık kapısını geçersiz kılar)',
    forcePurgeWarning:
      'Bu işlem uzun süredir silinmiş dosyaların verisini sağlayıcıdan kalıcı olarak siler. Bunu yalnızca site dışı yedek ve bir geri yükleme denemesi hazır olduğunda yap.',
    run: 'Mutabakatı çalıştır',
    stats: {
      orphansPurged: 'Temizlenen yetimler',
      sessionsReconciled: 'Kapatılan oturumlar',
      sessionsScanned: 'Taranan oturumlar',
      bytesPurged: 'Silinen bayt',
      rowsChecked: 'Kontrol edilen satır',
      rowsMissingBytes: 'Verisi eksik satır',
      foldersUnreadable: 'Okunamayan klasör',
    },
    gated: {
      before: 'Saklama süresi dolan verinin silinmesi',
      strong: 'kapalı (D2 dayanıklılık)',
      middle: '— hiç veri silinmedi. Site dışı yedek ve geri yükleme denemesi hazır olunca',
      after: 'ayarını aç.',
    },
    integrity: 'Tutarlılık',
    skipped: (reason) => `Atlandı — ${reason}.`,
  },
}
